import React, { Fragment } from 'react';

import clsx from 'clsx';
import { Link } from 'react-router-dom';

import { Box, IconButton } from '@material-ui/core';

import projectLogo from '../../../assets/images/nepal-logo.png';

const HeaderLogo = (props) => {

  return (
    <Fragment>
      <div className={clsx('app-header-logo', {})}>
        <Link to="/admin/DashboardDefault" className="header-logo-wrapper-link">
          <Box
            className="header-logo-wrapper"

            title="COOPERATIVE TRAINING AND RESEARCH CENTER">
            <IconButton
              color="primary"
              size="medium"
              className="header-logo-wrapper-btn">
              <img
                className="app-header-logo-img"
                alt=" React Admin Dashboard with Material-UI Free"
                src={projectLogo}
              />

            </IconButton>

            <Box className="header-logo-text">
              <div style={{ fontSize: '20px' }}>{props.setting ? props.setting.name : ''}</div>
              <div style={{ fontSize: '15px', marginTop: -5 }}>{props.setting ? props.setting.address : ''}</div>
              <div style={{ fontSize: '15px', marginTop: -5 }}>{props.setting ? props.setting.phone_number : ''}</div>
            </Box>
          </Box>
        </Link>
      </div>
      <div style={{ width: '650px' }} />
      <div className={clsx('app-header-logo', {})} >
        <Link to="/admin/DashboardDefault" className="header-logo-wrapper-link">
          {props.displayTrainingData && <Box
            className="header-logo-wrapper">
            <Box className="header-logo-text">
              {typeof props.traningDate != 'undefined' && props.traningDate.comittee ? <div style={{ fontSize: '20px' }}>प्रशिक्षण नाम <span style={{ marginLeft: 5 }} />:{props.traningDate.training.length >= 25 ? `${props.traningDate.training.substr(0, 25)}...` : props.traningDate.training}</div> : ''}
              {typeof props.traningDate != 'undefined' && props.traningDate.comittee ? <div style={{ fontSize: '15px', marginTop: -5 }}>संयोजक  <span style={{ marginLeft: 55 }} />:{props.traningDate.comittee.sayojug}</div> : ''}
              {typeof props.traningDate != 'undefined' && props.traningDate.comittee ? <div style={{ fontSize: '15px', marginTop: -5 }}>सह संयोजक  <span style={{ marginLeft: 33 }} />:{props.traningDate.comittee.saha_sayojug}</div> : ''}
              {typeof props.traningDate != 'undefined' && props.traningDate.comittee ? <div style={{ fontSize: '15px', marginTop: -5 }}>प्राविधिक कर्मचारी<span style={{ marginLeft: 7 }} />:{props.traningDate.comittee.prabidik_karmachari}</div> : ''}
              {typeof props.traningDate != 'undefined' && props.traningDate.comittee ? <div style={{ fontSize: '15px', marginTop: -5 }}>कार्यालय सहयोगी <span style={{ marginLeft: 4 }} />:{props.traningDate.comittee.karyalaya_sahayogi}</div> : ''}
            </Box>
          </Box>}

        </Link>
      </div>

    </Fragment>
  );
};

export default HeaderLogo;
